<template>
  <div class="wrapper">
    <img class="wrapperBg" width="100%" height="100%" src="../../assets/img/sy/dzp/zjjlbg1.png">
    <div class="backBtn" @click="goBack">
      <img src="../../assets/img/sy/dzp/back.png">
    </div>
    <div class="list">
      <van-list
        v-if="!!token"
        v-model="data.loading"
        :finished="data.finished"
        finished-text="已经没有更多了"
        @load="getPrizeList">
        <table cellpadding="0" cellspacing="0">
          <tbody>
            <tr class="tr" v-for="(item,index) in data.list" :key="index">
              <td>
                <div class="avatar">
                  <img :src="item.icon"/>
                </div>
              </td>
              <td>
                <div class="text">{{item.name}}</div>
              </td>
              <td class="icon">
                <div class="avatar2">
                  <img src="../../assets/img/sy/dzp/icon.png"/>
                </div>
                <div class="t">{{item.money}}</div>
              </td>
              <td>
                <div>{{item.time}}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </van-list>
    </div>
  </div>
</template>
<script>
  import {List, Cell } from 'vant';
  import axios from 'axios'
  import dsBridge from '../../component/dsbridge' 

  export default {
    name: 'sy_dzp_prize',
    data () {
      return {
        API_DOMAIN: window.location.host.match(/mp\.le/) ? 'https://test-api-svoice.le.com' : 'https://api-svoice.le.com',
        // token: '18bd9bd86b4920875fad92faf0494fcc0c632e4bc4ca7ba6398b0d5fefb6be4b239e64a66c26fd5df4092463626bb4250e28f871b905c482c7abc06e377eac452d7d34479268516b3eb29de00ba500ec',
        // pcode: '230110000',
        token:'',
        pcode:'',
        version:'',
        //奖品列表
        prize_list: [], 
        data: {
          list: [],
          page: 1,
          giftIndex: 0,
          loading: false,
          finished: false,
          error: false
        },
        pagesize: 10,
        user:{
          name:'',
          money:'',
          headImg: ''
        },
        userImg: 'https://i0.letvimg.com/lc04_lemf/201906/12/20/07/2x.png'
      }
    },
    components: {
      [List.name]: List,
      [Cell.name]: Cell
    },
    computed: {
    },
    async mounted (){
      await this.getUser();
    },
    methods: {
      async getPrizeList (){
        let prizeListRet,
            prizeListUrl = `${this.API_DOMAIN}/sales/game/draw/list?pagenum=${this.data.page}&pagesize=${this.pagesize}&accesstoken=${this.token}&pcode=${this.pcode}&version=${this.version}`;
        try {
          prizeListRet = await axios.get(prizeListUrl, { timeout: 3000 });
        } catch (error) {
          try {
            prizeListRet = await axios.get(prizeListUrl, { timeout: 3000 });
          } catch (error) {
            this.$notify('获取中奖记录失败！，请刷新页面')
            return
          }
        }
        let prizeListData = prizeListRet.data.data || '';
        if (!prizeListData){
          this.$notify('获取中奖记录失败！，请刷新页面')
          return
        }
        if(!prizeListData.list) {
          this.data.loading = false;
          this.data.finished = true;
          return
        }
        const gifts = prizeListData.list.map((gift) => {
          return {
            id: gift.giftid,
            icon: gift.icon,
            name: gift.name,
            money: gift.price,
            time: gift.create_time
          }
        });
        const oldList = this.data.list;
        const newList = Array.prototype.concat(oldList, gifts);
        this.data.list = newList;
        // 加载状态结束
        this.data.loading = false;
        // 数据全部加载完成
        if (prizeListData.list.length === 0) {
          this.data.finished = true;
          return
        }
        this.data.page++
      },
      async getUser (){
        dsBridge.call('getTokenAsync', ret => {
          try {
            const userInfo = JSON.parse(ret)
            this.token = userInfo.token
            if (!this.token || this.token === '') {
              this.user.name = '请登录'
              this.user.money = '0'
              return
            }
            dsBridge.call('getAppInfoAsync', async ret => {
              const appInfo = JSON.parse(ret);
              this.pcode = appInfo.pcode;
              this.version = appInfo.version;
            })
          } catch (e) {
            this.$notify('未知错误！，请刷新页面')
          }
        });
      },
      goBack (){
        this.$router.go(-1);
      }
    }
  }
</script>
<style scoped>
  body,
  html {
    overflow-y: hidden;
    overflow-x: hidden;
    user-select:none;
    height: 100%;
  }

  #app {
    height: 100%;
    background-color: #fe4a5f;
  }

  .wrapper {
    min-height: 100%;
    font-size: 12px;
    position: relative;
  }
  .backBtn {
    position: absolute;
    height: 43px;
    top: 0;
  }
  .backBtn img{
    height: 23px;
    margin-top: 20px;
    margin-left: 25px;
  }
  .list {
    position:absolute;
    top: 153px;
    left: 50%;
    margin-left: -150px;
    width: 300px;
	  height: 285px;
    overflow:auto;
  }
  .list .avatar img{
    width: 29px;
  }
  .list .text {
    width: 60px;
    overflow:hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }
  .list .icon {
    display: flex;
    align-items: center;
    justify-content : space-between;
  }
  .list .icon .t{
    width: 40px;
  }
  .list .avatar2 img{
    margin-top:2px;
    margin-right: 6px;
    width: 15px;
    height: 15px;
  }
  .list table {
    width: 300px;
  }
  .list .tr {
    display: flex;
    align-items: center;
    justify-content : space-between;
    height: 39px;
    border-bottom: 1px solid #e7e7e7;
  }
</style>